import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'hpf-image',
  templateUrl: './image.component.html'
})
export class ImageComponent implements OnInit {

  /** Constructor */
  constructor() {}

  /** Init */
  ngOnInit() {}

}
